export default __webpack_public_path__ + "static/media/gym.2128b040.svg";